import { Config } from "./types/types.js";

let config: Config;

if (process.env.NODE_ENV !== "production") {
  config = {
    mode: "real",
    servicePath: "https://demo.casinocontroller.com/lisboa/engine",
    // additional: true,
    // extraFields: {
    //   required: ["province_id"],
    //   optional: ["province_id", "phone_verification"],
    // },
  };
} else {
  config = window.register || {};
}

if (!config.onSuccess)
  config.onSuccess = config.additional && process.env.NODE_ENV !== "production"
    ? (login?: string, pass?: string, userId?: number) => {
      console.log(login, pass, userId);
      return Promise.resolve();
    } :
    () => {
      document.location.href =
        window.location.origin +
        window.location.pathname +
        (config.hash ? "?hash=" + config.hash : "");
      return Promise.resolve();
    };

export default config;